angular.module('app').directive('question', function() {
    return {
        restrict: 'E',
        templateUrl: '/static/gallery/templates/question.html',
        scope: {
            'answers': '=answers',
            'question': '=question',
            'id': '@questionId',
            'change': '&qOnChange'
        },
        controller: function($scope, $filter) {
            "ngInject";
            var numberFormatter = $filter('number', 2);

        }
    };
});
